module.exports = __webpack_public_path__ + "img/Reaktorerkundungskraftwagen.11e888a2.svg";